import Vue from 'vue';
import Shipment from './Shipment';
import './money';

new Vue({
  el: '#review',

  mixins: [Shipment],

  data: window?.Contraversus?.cart ?? {},

  computed: {
    /**
     * Get the cart total.
     *
     * @returns {number}
     */
    total () {
      return this.subtotal + this.fee;
    },
  },
});
